import React from 'react';
import styled, { keyframes } from 'styled-components';
import { useTranslation } from 'react-i18next';
import { AUTODIAG } from './autodiagChoiceTokens';

// Aperçu du parcours assistant (« montrer, pas décrire ») : un échange
// typique, bulles + indicateur de saisie. Purement décoratif — le contenu
// réel est porté par le titre/description et l'aria-label de la carte,
// d'où le aria-hidden posé par le parent (AutodiagFlowCard).
// Tout est en <span> : ce bloc vit DANS un <button> (contenu phrasé only).

const blink = keyframes`
  0%, 80%, 100% { opacity: 0.25; transform: translateY(0); }
  40% { opacity: 1; transform: translateY(-2px); }
`;

// min-height (pas height fixe) : à zoom texte 200% (WCAG 1.4.4) ou avec une
// traduction plus longue, le contenu doit pouvoir grandir au lieu de
// déborder — l'alignement des deux cartes est garanti par le même token.
const Wrap = styled.span`
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-height: ${AUTODIAG.previewHeight}px;
  justify-content: flex-end;
`;

const Bubble = styled.span`
  display: block;
  max-width: 85%;
  padding: 6px 11px;
  font-size: 12px;
  line-height: 1.35;
  letter-spacing: ${AUTODIAG.bodyTracking};
  color: ${AUTODIAG.dark};
  border-radius: 14px;
`;

const BubbleUser = styled(Bubble)`
  align-self: flex-end;
  background: ${AUTODIAG.white};
  border-bottom-right-radius: 4px;
`;

const BubbleAssistant = styled(Bubble)`
  align-self: flex-start;
  background: rgba(255, 255, 255, 0.65);
  border-bottom-left-radius: 4px;
`;

const Typing = styled.span`
  align-self: flex-start;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 7px 11px;
  background: rgba(255, 255, 255, 0.65);
  border-radius: 14px;
  border-bottom-left-radius: 4px;
`;

const Dot = styled.span`
  display: block;
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: ${AUTODIAG.dark};
  animation: ${blink} 1.2s infinite ease-in-out;
  &:nth-child(2) {
    animation-delay: 0.2s;
  }
  &:nth-child(3) {
    animation-delay: 0.4s;
  }
  @media (prefers-reduced-motion: reduce) {
    animation: none;
    opacity: 0.6;
  }
`;

export default function AutodiagAssistantPreview() {
  const { t } = useTranslation();
  return (
    <Wrap>
      <BubbleUser>{t('autodiag.choice.preview.chat.user')}</BubbleUser>
      <BubbleAssistant>
        {t('autodiag.choice.preview.chat.assistant')}
      </BubbleAssistant>
      <Typing>
        <Dot />
        <Dot />
        <Dot />
      </Typing>
    </Wrap>
  );
}
